import {
  DropdownMenu,
  FormInput,
  SearchableDropdown,
} from "@/components/bnp-ui";
import { getCitiesByState, nigeriaStates } from "@/utils/location";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import PlacesAutocomplete from "../../AddressDropDown";
import { propertyStageMapping } from "../../Land";
import { get } from "http";

export const developmentTypeMapping = {
  "Joint-Venture": "joint-venture",
  "Off-Plan Sale": "off-plan-sale",
  "Sponsorship Contract": "sponsorship-contract",
  "Fractional Ownership": "fractional-ownership",
};

export const developmentStages = {
  "Funding Stage": "funding-stage",
  "Development Stage": "development-stage",
  "Delivery Stage": "delivery-stage",
};
export function getDevelopmentType(object: any, value: any) {
  return Object.keys(object).find((key) => object[key] === value);
}
const StepOne = ({ control, errors, setValue, developmentType }: any) => {
  const [selectedState, setSelectedState] = useState<any>(nigeriaStates[0]);
  const [cityOptions, setCityOptions] = useState<string[]>([]);
  useEffect(() => {
    if (selectedState) {
      const cities = getCitiesByState(selectedState);
      setCityOptions(cities);
    } else {
      setCityOptions([]);
    }
  }, [selectedState]);

  useEffect(() => {
    if (developmentType) {
      const key = getDevelopmentType(developmentTypeMapping, developmentType);
      if (key) {
        setValue("developmentType", developmentType);
      } else {
        setValue("developmentType", "");
      }
    }
  }, [developmentType, setValue]);

  return (
    <div>
      <div className="bg-bnp-teal text-grey-7 text-sm font-normal p-3 rounded-lg mb-4">
        <p>
          Describe the development opportunity in a few sentences. Focus on what
          makes this property special, its appeal, and the value it offers to
          potential developers. Keep it concise yet engaging to capture
          interest.
        </p>
      </div>

      <Controller
        name="title"
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <div>
            <FormInput
              type="text"
              name="title"
              value={value}
              label="Title"
              placeholder="Enter a captivating title"
              className="w-[100%]  h-[48px]"
              onChange={onChange}
              required
            />
            {errors?.title && (
              <p className="text-red-500 text-sm">
                {errors?.title?.message as string}
              </p>
            )}
          </div>
        )}
      />
      <div className=" lg:items-center flex flex-col lg:flex-row gap-[20px] w-[100%] mt-2">
        <div className="w-[100%] lg:w-1/2 mt-1 ">
          <PlacesAutocomplete control={control} errors={errors} />
        </div>

        <Controller
          name="developmentType"
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <div className="w-[100%] lg:w-1/2 flex flex-col gap-1">
              <p className="text-sm font-medium text-main-900">
                Development type <span className="text-red-500 text-sm">*</span>
              </p>
              <DropdownMenu
                name={"developmentType"}
                value={getDevelopmentType(developmentTypeMapping, value)}
                options={Object.keys(developmentTypeMapping)}
                onChange={(e) => {
                  //@ts-ignore
                  const apiValue = developmentTypeMapping[e.target.value];
                  onChange(apiValue);
                }}
              />
              {errors?.developmentType && (
                <p className="text-red-500 text-sm">
                  {errors?.developmentType?.message as string}
                </p>
              )}
            </div>
          )}
        />
      </div>

      <div className="flex flex-col lg:flex-row w-[100%] gap-[10px] mt-2">
        <Controller
          name="stage"
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <div>
              <FormInput
                type="text"
                name="stage"
                value={value}
                label="Development stage"
                placeholder="Development stage"
                className="w-[100%]  h-[48px]"
                onChange={onChange}
                required
              />
              {errors?.stage && (
                <p className="text-red-500 text-sm">
                  {errors?.stage?.message as string}
                </p>
              )}
            </div>
          )}
        />

        <div className="w-[100%] lg:w-2/3  ">
          {" "}
          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <div>
                <FormInput
                  type="text"
                  isTextArea
                  name="description"
                  value={value}
                  label="Description"
                  placeholder="Give a brief description of the development"
                  className="w-[100%]"
                  onChange={onChange}
                  required
                />
                {errors?.description && (
                  <p className="text-red-500 text-sm">
                    {errors?.description?.message as string}
                  </p>
                )}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default StepOne;
